module.exports = __webpack_public_path__ + "img/9788931010473.85985535.jpg";